export default ({ request }) => ({
  /**
     * 宣讲会报名
     * @param data
     * @returns {*}
     * @constructor
     */
  RECRUIT_TRIP_ENROLL (data = {}) {
    // 接口请求
    return request({
      url: '/enroll',
      method: 'POST',
      data
    })
  }
})

